import { takeLatest } from 'redux-saga/effects';
import {
  getTimeCardListSuccess, getTimeCardListFail,
  getTimeCardDetailsSuccess, getTimeCardDetailsFail,
  getUserAttendanceStatsSuccess,getUserAttendanceStatsFail, 
} from './timeCardState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/timekeeping/time-cards');
const redirectData = {route:'/console/time-cards', mode: 'list', recordId:0 };
const modelName = 'Timecard';
const modelId = 'hol_id';

function* getTimeCardList(data) {
	const filters = data.payload;
	yield doCrudCall(
		() => crudService.getList(filters), 
		(responseData) => getTimeCardListSuccess({
            ...responseData,
            filters: filters 
        }),
		getTimeCardListFail, null, null, LOADING_MSG);
}

function* getTimeCardDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getTimeCardDetailsSuccess, 
		getTimeCardDetailsFail, null, null, LOADING_MSG);		
}

function* doTimeCardCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getTimeCardDetailsSuccess, 
		getTimeCardDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doTimeCardUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getTimeCardDetailsSuccess, 
		getTimeCardDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doTimeCardDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getTimeCardDetailsSuccess, 
		getTimeCardDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getUserTimeCardToday(data){
	const { userId } = data.payload;
	const endpoint = `user/${userId}/today`;
	yield doCrudCall(
		() => crudService.doGetRequest(endpoint, data.payload), 
		getTimeCardDetailsSuccess, 
		getTimeCardDetailsFail, null, null, LOADING_MSG);
}

function* doTimeCardPunch(data){
	const { recordId, typeName, typeId } = data.payload;
	const endpoint = `${recordId}/punch/${typeId}`;
	yield doCrudCall(
		() => crudService.doPostRequest(endpoint, data.payload), 
		getTimeCardDetailsSuccess, 
		getTimeCardDetailsFail,
		updateRecordSuccess(modelName),
		null, `Saving time card punch ${typeName}`)		
}


function* getUserAttendanceStats(action) {
	const { userId, from, to } = action.payload;
	let endpoint = `user/${userId}/attendance-stats`;

	yield doCrudCall(
		() => crudService.doGetRequest(endpoint, action.payload),
		getUserAttendanceStatsSuccess,
		getUserAttendanceStatsFail,
		null,
		null,
		LOADING_MSG
  );
}



function* timeCardSaga() {
  yield takeLatest('timeCard/getTimeCardList', getTimeCardList);
  yield takeLatest('timeCard/getTimeCardDetails', getTimeCardDetails);
  yield takeLatest('timeCard/doTimeCardCreate', doTimeCardCreate);
  yield takeLatest('timeCard/doTimeCardUpdate', doTimeCardUpdate);
  yield takeLatest('timeCard/doTimeCardDelete', doTimeCardDelete);  
  yield takeLatest('timeCard/getUserTimeCardToday', getUserTimeCardToday);  
  yield takeLatest('timeCard/doTimeCardPunch', doTimeCardPunch);  
  yield takeLatest('timeCard/getUserAttendanceStats', getUserAttendanceStats);


}

export default timeCardSaga;
